<template>
  <div>
    <h1 class="mb-8 font-bold text-2xl md:text-3xl ">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('clients')">Klienci</inertia-link>
      <span class="text-shtax-400 font-medium">/</span>
      Nowy klient
    </h1>

    <div class="flex flex-wrap">
      <div class="bg-white rounded-md shadow overflow-hidden w-full xl:w-1/2">
        <form @submit.prevent="store">
          <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
            <multiselect-input v-model="form.firma" :error="form.errors.firma" class="pr-6 pb-8 w-full lg:w-1/2" :options="firmy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Firma [WAPRO]" :searchable="true" />

            <multiselect-input v-model="form.user" :error="form.errors.user" class="pr-6 pb-8 w-full lg:w-1/2" :options="users" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Opiekun" />

            <multiselect-input v-model="form.kontrahent" :error="form.errors.kontrahent" class="pr-6 pb-8 w-full" :options="kontrahenci" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Kontrahent [WAPRO]" :searchable="true" />
            
            <text-input v-model="form.nazwa_pelna" :error="form.errors.nazwa_pelna" class="pr-6 pb-8 w-full" label="Nazwa" v-if="form.firma == null" :isLoading="isLoading" />  
            

            <text-input v-model="form.nip" :error="form.errors.nip" class="pr-6 pb-8 w-full lg:w-1/3" label="NIP" v-if="form.firma == null" />
            <text-input v-model="form.regon" :error="form.errors.regon" class="pr-6 pb-8 w-full lg:w-1/3" label="REGON" v-if="form.firma == null" :isLoading="isLoading" />
            <text-input v-model="form.krs" :error="form.errors.krs" class="pr-6 pb-8 w-full lg:w-1/3" label="KRS" v-if="form.firma == null" :isLoading="isLoading" />

            <div class="mb-8 w-full" v-if="form.kontrahent == null">
              <div @click="show_address=!show_address">
                <h3 class="text-shtax-500">
                  Dane adresowe
                  <span v-if="!show_address"><fa icon="chevron-down" class="w-4 h-4 mr-2" fixed-width /><small>(rozwiń)</small></span>
                  <span v-if="show_address"><fa icon="chevron-up" class="w-4 h-4 mr-2" fixed-width /><small>(zwiń)</small></span>
                </h3>
              </div>
              <div v-if="show_address" class="flex flex-wrap pt-8">
                <input type="hidden" v-model="form.kraj_symbol">
                <text-input v-model="form.wojewodztwo" :error="form.errors.wojewodztwo" class="pr-6 pb-8 w-full lg:w-1/2" label="Województwo" :isLoading="isLoading" v-if="form.kontrahent == null" />
                <text-input v-model="form.powiat" :error="form.errors.powiat" class="pr-6 pb-8 w-full lg:w-1/2" label="Powiat" :isLoading="isLoading" v-if="form.kontrahent == null" />
                <text-input v-model="form.gmina" :error="form.errors.gmina" class="pr-6 pb-8 w-full lg:w-1/2" label="Gmina" :isLoading="isLoading" v-if="form.kontrahent == null" />
                <div class=" w-1/2"></div>
                <text-input v-model="form.kod_pocztowy" :error="form.errors.kod_pocztowy" class="pr-6 pb-8 w-full lg:w-1/2" label="Kod pocztowy" :isLoading="isLoading" v-if="form.kontrahent == null" />
                <text-input v-model="form.miejscowosc" :error="form.errors.miejscowosc" class="pr-6 pb-8 w-full lg:w-1/2" label="Miejscowość" :isLoading="isLoading" v-if="form.kontrahent == null" />
                <text-input v-model="form.ulica_lokal" :error="form.errors.ulica_lokal" class="pr-6 pb-8 w-1/2" label="Ulica" :isLoading="isLoading" v-if="form.kontrahent == null" />
                <text-input v-model="form.nr_domu" :error="form.errors.nr_domu" class="pr-6 pb-8 w-1/4" label="Nr domu" :isLoading="isLoading" v-if="form.kontrahent == null" />
                <text-input v-model="form.nr_lokalu" :error="form.errors.nr_lokalu" class="pr-6 pb-8 w-1/4" label="Nr lokalu" :isLoading="isLoading" v-if="form.kontrahent == null" />
              </div>
            </div>

            <shtax-text-area-input class="pr-6 pb-8 w-full" v-model="form.rodzaj_zus" :error="form.errors.rodzaj_zus" label="Rodzaj ZUS"  />
            <shtax-text-area-input class="pr-6 pb-8 w-full" v-model="form.umowa_o_prace" :error="form.errors.umowa_o_prace" label="Umowa o pracę"  />

            <shtax-checkbox class="pt-8 pr-6 pb-8 w-full lg:w-1/2" v-model:checked.sync="form.is_jdg" :error="form.errors.is_jdg" :checked="form.is_jdg" label="Jednoosobowa działalność gospodarcza"  />
            <text-input v-model="form.start_dg" :error="form.errors.start_dg" class="pr-6 pb-8 w-full lg:w-1/2" label="Data rozpoczęcia DG" type="date" :isLoading="isLoading" />

            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/2" v-model:checked.sync="form.platnik_vat" :error="form.errors.platnik_vat" :checked="form.platnik_vat" label="Płatnik VAT" v-if="form.firma == null" />
            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/2" v-model:checked.sync="form.vat_czynny" :error="form.errors.vat_czynny" :checked="form.vat_czynny" label="Czynny podatnik VAT" v-if="form.kontrahent == null" />

            <div class="mb-8 w-full" v-if="form.firma == null">
              <div @click="show_rej=!show_rej">
                <h3 class="text-shtax-500">
                  Dane rejestrowe
                  <span v-if="!show_rej"><fa icon="chevron-down" class="w-4 h-4 mr-2" fixed-width /><small>(rozwiń)</small></span>
                  <span v-if="show_rej"><fa icon="chevron-up" class="w-4 h-4 mr-2" fixed-width /><small>(zwiń)</small></span>
                </h3>
              </div>
              <div v-if="show_rej" class="flex flex-wrap pt-8">
                <text-input v-model="form.organ_rej" :error="form.errors.organ_rej" class="pr-6 pb-8 w-full lg:w-1/2" label="Organ" :isLoading="isLoading" />
                <text-input v-model="form.organ_rej_sym" :error="form.errors.organ_rej_sym" class="pr-6 pb-8 w-full lg:w-1/2" label="Kod organu" :isLoading="isLoading" />
                <text-input v-model="form.rodzaj_rej" :error="form.errors.rodzaj_rej" class="pr-6 pb-8 w-full lg:w-1/2" label="Rodzaj rejestru" :isLoading="isLoading" />
                <text-input v-model="form.rodzaj_rej_sym" :error="form.errors.rodzaj_rej_sym" class="pr-6 pb-8 w-full lg:w-1/2" label="Kod rejestru" :isLoading="isLoading" />
                <text-input v-model="form.data_rej" :error="form.errors.data_rej" class="pr-6 pb-8 w-full lg:w-1/2" label="Data wpisu do rejestru" type="date" :isLoading="isLoading" />
                <text-input v-model="form.numer_rej" :error="form.errors.numer_rej" class="pr-6 pb-8 w-full lg:w-1/2" label="Numer w rejestrze" :isLoading="isLoading" />
              </div>
            </div>

            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/2" v-model:checked.sync="form.upl_1" :error="form.errors.upl_1" :checked="form.upl_1" label="Złożone UPL-1" />
            <shtax-checkbox class="pr-6 pb-8 w-1/2 lg:w-1/2" v-model:checked.sync="form.zus_pel" :error="form.errors.zus_pel" :checked="form.zus_pel" label="Złożone pełnomocnictwo ZUS-PEL" />

            <multiselect-input v-model="form.urzad" :error="form.errors.urzad" class="pr-6 pb-8 w-full" :options="urzedy" track_by="id" opt_label="name" :multiple="false" :close_on_select="true" label="Urząd Skarbowy" :searchable="true" />

          </div>
          <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
            <loading-button :loading="form.processing" class="btn-shtax ml-auto" type="submit">Stwórz klienta</loading-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import BlockedMessage from '@/ShtaxComponents/BlockedMessage'
import ShtaxCheckbox from '@/ShtaxComponents/Checkbox'
import ShtaxTextAreaInput from '@/ShtaxComponents/TextAreaInput'
import MultiselectInput from '@/ShtaxComponents/MultiselectInput'
import Swal from 'sweetalert2'
import axios from 'axios'

export default {
  metaInfo() {
    return { title: 'Nowy klient' }
  },
  components: {
    Icon,
    LoadingButton,
    SelectInput,
    TextInput,
    BlockedMessage,
    ShtaxCheckbox,
    ShtaxTextAreaInput,
    MultiselectInput
  },
  layout: Layout,
  props: {
    users: Array,
    firmy: Array,
    kontrahenci: Array,
    urzedy: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        nazwa_pelna: null,
        ulica_lokal: null,
        kod_pocztowy: null,
        miejscowosc: null,
        rodzaj_zus: null,
        umowa_o_prace: null,
        is_jdg: false,
        upl_1: false,
        zus_pel: false,
        nip: null,
        regon: null,
        start_dg: null,
        krs: null,
        user: null,
        firma: null,
        platnik_vat: true,
        data_rej: null,
        numer_rej: null,
        organ_rej: null,
        organ_rej_sym: null,
        rodzaj_rej: null,
        rodzaj_rej_sym: null,
        wojewodztwo: null,
        powiat: null,
        kontrahent: null,
        kraj_symbol: 'PL',
        nr_domu: '',
        nr_lokalu: '',
        gmina: '',
        urzad: {id: 35, name: 'Pierwszy Przykładowy Urząd Skarbowy'},
        vat_czynny: true
      }),
      isLoading: false,
      show_rej: false,
      show_address: false
    }
  },
  methods: {
    store() {
      this.form.post(this.route('clients.store'))
    },

    validateNip(nip) {
      nip += '';
      nip = nip.replace(/[^0-9]+/g,'');
      if(nip.length < 10) return false;
      if(nip.length > 10) return false;
      var controlSum = 0;
      
      controlSum += parseInt( nip.charAt(0) ) * 6;
      controlSum += parseInt( nip.charAt(1) ) * 5;
      controlSum += parseInt( nip.charAt(2) ) * 7;
      controlSum += parseInt( nip.charAt(3) ) * 2;
      controlSum += parseInt( nip.charAt(4) ) * 3;
      controlSum += parseInt( nip.charAt(5) ) * 4;
      controlSum += parseInt( nip.charAt(6) ) * 5;
      controlSum += parseInt( nip.charAt(7) ) * 6;
      controlSum += parseInt( nip.charAt(8) ) * 7;
      
      if( (controlSum%11) == parseInt( nip.charAt(9) ) ) {
          return true;
      } else {
          return false;
      }
    },

    getGusData() {
      self = this
      self.isLoading = true
      axios.get('/api/gus/'+ this.form.nip)
        .then(function (response) {
          // handle success
          // console.log(response.data)
          let gus = response.data.gus[0]

          if (gus.reports.BIR11OsFizycznaDzialalnoscCeidg.ErrorCode)
            self.osobowoscPrawna(gus)
          else
            self.osobaFizyczna(gus)


          

          self.isLoading = false
        })
        .catch(function (error) {
          // handle error
          // console.log(error)
          Swal.fire({
            title: 'Błąd z GUS?',
            icon: 'error',
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK',
            text: error.message
          })

          self.isLoading = false
        })
      ;


    },

    osobaFizyczna(gus) {
      let form = this.form
      form.nazwa_pelna = gus.name
      form.regon = gus.regon
      form.ulica_lokal = gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fiz_adSiedzUlica_Nazwa
      form.kod_pocztowy = gus.zipCode
      form.miejscowosc = gus.city ?? gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fiz_adSiedzMiejscowosc_Nazwa
      form.wojewodztwo = gus.province
      form.powiat = gus.district
      form.gmina = gus.community ?? gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fiz_adSiedzGmina_Nazwa

      form.start_dg = gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fiz_dataRozpoczeciaDzialalnosci
      form.data_rej = gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fizC_dataWpisuDoRejestruEwidencji
      form.numer_rej = gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fizC_numerWRejestrzeEwidencji
      form.is_jdg = gus.reports.BIR11OsFizycznaDaneOgolne.fiz_podstawowaFormaPrawna_Symbol == '9'
      form.organ_rej = gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fizC_OrganRejestrowy_Nazwa
      form.organ_rej_sym = gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fizC_OrganRejestrowy_Symbol
      form.rodzaj_rej = gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fizC_RodzajRejestru_Nazwa
      form.rodzaj_rej_sym = gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fizC_RodzajRejestru_Symbol
      form.nr_domu = gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fiz_adSiedzNumerNieruchomosci
      form.nr_lokalu = gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fiz_adSiedzNumerLokalu
      form.kraj_symbol = gus.reports.BIR11OsFizycznaDzialalnoscCeidg.fiz_adSiedzKraj_Symbol ?? 'PL'
    },

    osobowoscPrawna(gus) {
      let form = this.form
      form.nazwa_pelna = gus.name
      form.regon = gus.regon
      form.krs = gus.krs ?? gus.reports.BIR11OsPrawna.praw_numerWRejestrzeEwidencji
      form.ulica_lokal = gus.reports.BIR11OsPrawna.praw_adSiedzUlica_Nazwa
      form.nr_domu = gus.reports.BIR11OsPrawna.praw_adSiedzNumerNieruchomosci
      form.nr_lokalu = gus.reports.BIR11OsPrawna.praw_adSiedzNumerLokalu
      form.kod_pocztowy = gus.zipCode
      form.miejscowosc = gus.city ?? gus.reports.BIR11OsPrawna.praw_adSiedzMiejscowosc_Nazwa
      form.kraj_symbol = gus.reports.BIR11OsPrawna.praw_adSiedzKraj_Symbol ?? 'PL'
      form.wojewodztwo = gus.province
      form.powiat = gus.district
      form.gmina = gus.community ?? gus.reports.BIR11OsPrawna.praw_adSiedzGmina_Nazwa

      form.start_dg = gus.reports.BIR11OsPrawna.praw_dataRozpoczeciaDzialalnosci
      form.data_rej = gus.reports.BIR11OsPrawna.praw_dataWpisuDoRejestruEwidencji
      form.numer_rej = gus.reports.BIR11OsPrawna.praw_numerWRejestrzeEwidencji
      form.is_jdg = false
      form.organ_rej = gus.reports.BIR11OsPrawna.praw_organRejestrowy_Nazwa
      form.organ_rej_sym = gus.reports.BIR11OsPrawna.praw_organRejestrowy_Symbol
      form.rodzaj_rej = gus.reports.BIR11OsPrawna.praw_rodzajRejestruEwidencji_Nazwa
      form.rodzaj_rej_sym = gus.reports.BIR11OsPrawna.praw_rodzajRejestruEwidencji_Symbol
    }

  },

  computed: {
    nip() {
      return this.form.nip 
    }
  },

  watch: {
    nip() {
      if (this.validateNip(this.form.nip)) {
        // this.isLoading = true
        this.form.errors.nip = ""
        Swal.fire({
          title: 'Pobrać dane klienta z GUS?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Tak, pobierz!',
          cancelButtonText: 'Nie'
        }).then((result) => {
          if (result.isConfirmed) {
            // this.$inertia.get('api/gus/'+ this.form.nip, {
            //   onSuccess: () => {
            //     console.log('Sukces')
            //   }
            // })
            this.getGusData()
            
          }
        })
        
      } else {
        // this.isLoading = false
        this.form.errors.nip = "Błędny numer NIP"
      }
    }
  },

}
</script>